import { alpha } from '@mui/material';
const useTextFieldStyles = () => ({
    border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
    borderRadius: '14px',
    width: '100%',
    height: 'auto',
    paddingLeft: '10px',
    paddingRight: '10px',
    background: (theme) => theme.palette.common.grey8,
    display: 'flex',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '14px',
    wordBreak: 'keep-all',
    overflowX: 'hidden',
    lineHeight: '22px',
    letterSpacing: 0,
    color: (theme) => theme.palette.text.secondary,
    minHeight: '53px',
    alignItems: 'center'
});
export default useTextFieldStyles;
